<template>
  <div class="online-status-dote" :class="[size, { online }]" v-if="online"></div>
</template>

<script>
export default {
  name: 'online',
  props: {
    online: Boolean,
    size: String,
  },
}
</script>

<style lang="scss">
.online-status-dote {
  width: 13px;
  height: 13px;
  border: 2px solid $white;
  background: $dark;
  border-radius: 50%;
  flex-shrink: 0;

  &.online {
    background: $green;
  }

  &.sm {
    width: 9px;
    height: 9px;
  }

  @include PC {
    &.lg,
    &.lg-pc,
    &.online-lg {
      width: 21px;
      height: 21px;
      border: 4px solid $white;
    }
  }
}
</style>
